
<template>
  <div class="icon-social">
    <!-- Email -->
    <a
      v-if="contact.email"
      :href="`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(contact.email)}`"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Email DITAP"
      class="icon-social__link"
    >
      <Icon icon="mdi:email-outline" />
    </a>

    <!-- WhatsApp -->
    <a
      v-if="whatsappHref"
      :href="whatsappHref"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp DITAP"
      class="icon-social__link"
    >
      <Icon icon="simple-icons:whatsapp" />
    </a>

    <!-- Instagram -->
    <a
      v-if="contact.instagram_url"
      :href="contact.instagram_url"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram DITAP"
      class="icon-social__link"
    >
      <Icon icon="simple-icons:instagram" />
    </a>

    <!-- TikTok -->
    <a
      v-if="contact.tiktok_url"
      :href="contact.tiktok_url"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="TikTok DITAP"
      class="icon-social__link"
    >
      <Icon icon="simple-icons:tiktok" />
    </a>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue'
import api from '@/services/axios'

export default {
  name: 'IconSocial',

  components: {
    Icon
  },

  data() {
    return {
      contact: {
        email: '',
        whatsapp: '',
        instagram_url: '',
        tiktok_url: ''
      }
    }
  },

  computed: {
    whatsappHref() {
      const number = String(this.contact.whatsapp || '')
        .replace(/\D/g, '')

      return number ? `https://wa.me/${number}` : ''
    }
  },

  async mounted() {
    try {
      const response = await api.get('/public/platform-contact')

      if (response.data?.success && response.data?.data) {
        this.contact = {
          ...this.contact,
          ...response.data.data
        }
      }
    } catch (error) {
      console.error(
        'Gagal memuat kontak General Settings:',
        error
      )
    }
  }
}
</script>

<style scoped>
.icon-social {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.icon-social__link {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  background: var(--color-background-secondary);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  text-decoration: none;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}

.icon-social__link :deep(svg) {
  width: 18px;
  height: 18px;
}

.icon-social__link:hover {
  color: var(--color-text);
  background: var(--color-background);
  border-color: var(--color-border-hover);
  transform: translateY(-2px);
}

.icon-social__link:active {
  transform: translateY(0) scale(0.96);
}

.icon-social__link:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 3px;
}
</style>
